import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getSystemSetting, updatePointSetting } from '@/services/systemsetting';
var SEO = function SEO() {
  return import("./components/SEO");
};
var basicSetting = function basicSetting() {
  return import("./components/basicSetting");
};
var payment = function payment() {
  return import("./components/payment");
};
var transportCompany = function transportCompany() {
  return import("./components/transportCompany");
};
var other = function other() {
  return import("./components/other");
};
var emailSetting = function emailSetting() {
  return import("./components/emailSetting");
};
var agreement = function agreement() {
  return import("./components/agreement");
};
var customerService = function customerService() {
  return import("./components/customerService");
};
var rewardSetting = function rewardSetting() {
  return import("./components/rewardSetting");
};
import emailNotifySetting from './components/emailNotifySetting.vue';
import socileLogin from './components/socileLogin.vue';
import picWatermark from './components/picWatermark.vue';
import pagesetting from '@/pages/systemsettings/components/pagesetting.vue';
export default {
  name: 'basicSettings',
  components: {
    basicSetting: basicSetting,
    payment: payment,
    SEO: SEO,
    transportCompany: transportCompany,
    other: other,
    emailSetting: emailSetting,
    agreement: agreement,
    customerService: customerService,
    rewardSetting: rewardSetting,
    emailNotifySetting: emailNotifySetting,
    socileLogin: socileLogin,
    picWatermark: picWatermark,
    pagesetting: pagesetting
  },
  i18n: require('./i18n-basucSettings'),
  data: function data() {
    return {
      tabKey: '1',
      systemSetting: {},
      rewardData: {
        id: "",
        productPointRate: '',
        onePointMoney: '',
        evaluatePointRate: '',
        lastUpdateTime: ''
      },
      rules: {
        productPointRate: [{
          required: true,
          message: this.$t('publicuse.pleaseinput'),
          trigger: 'blur'
        }],
        onePointMoney: [{
          required: true,
          message: this.$t('publicuse.pleaseinput'),
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      var self = this;
      this.tabKey = activeKey;
    },
    loadData: function loadData() {
      //加载初始化数据
      var self = this;
      getSystemSetting().then(function (res) {
        if (res.data.code == 200) {
          self.systemSetting = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
    }
  }
};